/**

* © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile

* Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United

* States and/or other countries.

*/

import * as actionTypes from '../../Actions/TextManagement/TextManagementActionTypes';

const reducer = (state = [], action) => {
  switch (action.type) {
    case actionTypes.PROVIDER_SPECIALTY_DATA:
      return { ProviderSpecialtyData: action.ProviderSpecialtyData };
    default: return state;
  }
};

export default reducer;
